module.exports = __webpack_public_path__ + "img/ctrl-b-stub-down--.70a84679.svg";